import ModalPopup from "../../../components/newcomponents/ModalPopup";
import NotesCheckBox from "../../notes/component/NoteCheckBox";
import backarrow from "../../notes/images/backarrow.svg";
import MedicalReport from "../../contentReaderMarkdown/markdownRenderer";
import TemplateSkeleton from "../../notes/component/TemplateSkeleton";

const ViewSamplePopupComp = ({ onModalTapped, templateSummary, UpdateNotes, loading }) => {
   const modifiedText = templateSummary?.sample;
   const paraText = modifiedText?.replace(/[#*]/g, "");
   return (
      <>
         <ModalPopup onModalTapped={onModalTapped}>
            <div className="epic-template-modalPopup box-shadow ">
               {loading ? (
                  <TemplateSkeleton isviewSample={true} className="epic-para-sle" />
               ) : (
                  <>
                     <div className="epic-temp-summary-flex-container">
                        <div className="d-flex align-items-center cursor-pointer">
                           <div>
                              <img
                                 onClick={onModalTapped}
                                 src={backarrow}
                                 alt=""
                                 style={{ width: "20px", height: "20px" }}
                                 className="item"
                              />
                           </div>
                        </div>
                        <div className="temp-summary-title-text ml-4">{templateSummary?.title}</div>
                        <div>
                           <div className="item">
                              <NotesCheckBox
                                 width="51px"
                                 height="31px"
                                 tempId={templateSummary?.id}
                                 isDisable={templateSummary?.isDisable}
                                 UpdateNotes={UpdateNotes}
                              />
                           </div>
                        </div>
                     </div>
                     <div className="epic-summary-para-text epic-custom-temp-truncate ">{paraText}</div>
                     <div className="epic-summary-container">
                        {/* <div className="text-center summary-title-text">Sample Note</div> */}
                        <div className="epic-scrole-width-temp scrollbar-notes">
                           <MedicalReport content={templateSummary?.sample} />
                        </div>
                     </div>
                  </>
               )}
            </div>
         </ModalPopup>
      </>
   );
};

export default ViewSamplePopupComp;
